module.exports = __webpack_public_path__ + "9ef9962c900d67448b6edc7b73a72ca5.jpg";